import { GroupHeadingProps } from 'react-select'

import { AstraParagraph } from '../../../Typography/AstraParagraph/AstraParagraph'
import { SelectOption, SelectOptionGroup } from '../types'

export const groupHeadingClassName = () => ''

export function CustomGroupHeading<T>(props: GroupHeadingProps<SelectOption<T>, false, SelectOptionGroup<T>>) {
    return (
        <div className="flex h-8 select-none items-center gap-2 px-1">
            <AstraParagraph variant="body-small" weight="medium" className="text-muted">
                {props.children}
            </AstraParagraph>
        </div>
    )
}
